/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Honor_0_Item_2_TitleInputs */

const en_about_content_honor_0_item_2_title = /** @type {(inputs: About_Content_Honor_0_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2017 Iowa PGA Professional Development Award`)
};

const es_about_content_honor_0_item_2_title = /** @type {(inputs: About_Content_Honor_0_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premio al Desarrollo Profesional 2017 de la Iowa PGA`)
};

const de_about_content_honor_0_item_2_title = /** @type {(inputs: About_Content_Honor_0_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preis für berufliche Entwicklung der Iowa PGA 2017`)
};

const zh_about_content_honor_0_item_2_title = /** @type {(inputs: About_Content_Honor_0_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2017 年 Iowa PGA 职业发展奖`)
};

const ar_about_content_honor_0_item_2_title = /** @type {(inputs: About_Content_Honor_0_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جائزة التطوير المهني من Iowa PGA لعام 2017`)
};

const fr_about_content_honor_0_item_2_title = /** @type {(inputs: About_Content_Honor_0_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix du développement professionnel de la Iowa PGA 2017`)
};

const vi_about_content_honor_0_item_2_title = /** @type {(inputs: About_Content_Honor_0_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giải thưởng Phát triển Chuyên môn của Iowa PGA 2017`)
};

const sw_about_content_honor_0_item_2_title = /** @type {(inputs: About_Content_Honor_0_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuzo ya Iowa PGA ya Kukuza Taaluma ya 2017`)
};

const th_about_content_honor_0_item_2_title = /** @type {(inputs: About_Content_Honor_0_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รางวัลพัฒนาวิชาชีพของ Iowa PGA ประจำปี 2017`)
};

const bs_about_content_honor_0_item_2_title = /** @type {(inputs: About_Content_Honor_0_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nagrada Iowa PGA za profesionalni razvoj 2017`)
};

const ja_about_content_honor_0_item_2_title = /** @type {(inputs: About_Content_Honor_0_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2017年 Iowa PGA プロフェッショナル育成賞`)
};

const ko_about_content_honor_0_item_2_title = /** @type {(inputs: About_Content_Honor_0_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2017 Iowa PGA 전문성 개발상`)
};

const pt_about_content_honor_0_item_2_title = /** @type {(inputs: About_Content_Honor_0_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prêmio de Desenvolvimento Profissional da Iowa PGA 2017`)
};

const it_about_content_honor_0_item_2_title = /** @type {(inputs: About_Content_Honor_0_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premio per lo sviluppo professionale della Iowa PGA 2017`)
};

const sv_about_content_honor_0_item_2_title = /** @type {(inputs: About_Content_Honor_0_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA:s pris för professionell utveckling 2017`)
};

const nl_about_content_honor_0_item_2_title = /** @type {(inputs: About_Content_Honor_0_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prijs voor professionele ontwikkeling van de Iowa PGA 2017`)
};

const da_about_content_honor_0_item_2_title = /** @type {(inputs: About_Content_Honor_0_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA's pris for professionel udvikling 2017`)
};

const nb_about_content_honor_0_item_2_title = /** @type {(inputs: About_Content_Honor_0_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGAs pris for profesjonell utvikling 2017`)
};

const fi_about_content_honor_0_item_2_title = /** @type {(inputs: About_Content_Honor_0_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA:n ammatillisen kehityksen palkinto 2017`)
};

const pl_about_content_honor_0_item_2_title = /** @type {(inputs: About_Content_Honor_0_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nagroda Iowa PGA za rozwój zawodowy 2017`)
};

const ru_about_content_honor_0_item_2_title = /** @type {(inputs: About_Content_Honor_0_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Премия Iowa PGA за профессиональное развитие 2017`)
};

const tr_about_content_honor_0_item_2_title = /** @type {(inputs: About_Content_Honor_0_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2017 Iowa PGA Profesyonel Gelişim Ödülü`)
};

const hi_about_content_honor_0_item_2_title = /** @type {(inputs: About_Content_Honor_0_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2017 Iowa PGA व्यावसायिक विकास पुरस्कार`)
};

const id_about_content_honor_0_item_2_title = /** @type {(inputs: About_Content_Honor_0_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penghargaan Pengembangan Profesional Iowa PGA 2017`)
};

const ms_about_content_honor_0_item_2_title = /** @type {(inputs: About_Content_Honor_0_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anugerah Pembangunan Profesional Iowa PGA 2017`)
};

const cs_about_content_honor_0_item_2_title = /** @type {(inputs: About_Content_Honor_0_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cena Iowa PGA za profesní rozvoj 2017`)
};

const el_about_content_honor_0_item_2_title = /** @type {(inputs: About_Content_Honor_0_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Βραβείο επαγγελματικής ανάπτυξης της Iowa PGA 2017`)
};

const he_about_content_honor_0_item_2_title = /** @type {(inputs: About_Content_Honor_0_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`פרס הפיתוח המקצועי של Iowa PGA לשנת 2017`)
};

const af_about_content_honor_0_item_2_title = /** @type {(inputs: About_Content_Honor_0_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2017 Iowa PGA-toekenning vir professionele ontwikkeling`)
};

const hu_about_content_honor_0_item_2_title = /** @type {(inputs: About_Content_Honor_0_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az Iowa PGA 2017-es szakmai fejlődési díja`)
};

/**
* | output |
* | --- |
* | "2017 Iowa PGA Professional Development Award" |
*
* @param {About_Content_Honor_0_Item_2_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_honor_0_item_2_title = /** @type {((inputs?: About_Content_Honor_0_Item_2_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Honor_0_Item_2_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_honor_0_item_2_title(inputs)
	if (locale === "de") return de_about_content_honor_0_item_2_title(inputs)
	if (locale === "zh") return zh_about_content_honor_0_item_2_title(inputs)
	if (locale === "ar") return ar_about_content_honor_0_item_2_title(inputs)
	if (locale === "fr") return fr_about_content_honor_0_item_2_title(inputs)
	if (locale === "vi") return vi_about_content_honor_0_item_2_title(inputs)
	if (locale === "sw") return sw_about_content_honor_0_item_2_title(inputs)
	if (locale === "th") return th_about_content_honor_0_item_2_title(inputs)
	if (locale === "bs") return bs_about_content_honor_0_item_2_title(inputs)
	if (locale === "ja") return ja_about_content_honor_0_item_2_title(inputs)
	if (locale === "ko") return ko_about_content_honor_0_item_2_title(inputs)
	if (locale === "pt") return pt_about_content_honor_0_item_2_title(inputs)
	if (locale === "it") return it_about_content_honor_0_item_2_title(inputs)
	if (locale === "sv") return sv_about_content_honor_0_item_2_title(inputs)
	if (locale === "nl") return nl_about_content_honor_0_item_2_title(inputs)
	if (locale === "da") return da_about_content_honor_0_item_2_title(inputs)
	if (locale === "nb") return nb_about_content_honor_0_item_2_title(inputs)
	if (locale === "fi") return fi_about_content_honor_0_item_2_title(inputs)
	if (locale === "pl") return pl_about_content_honor_0_item_2_title(inputs)
	if (locale === "ru") return ru_about_content_honor_0_item_2_title(inputs)
	if (locale === "tr") return tr_about_content_honor_0_item_2_title(inputs)
	if (locale === "hi") return hi_about_content_honor_0_item_2_title(inputs)
	if (locale === "id") return id_about_content_honor_0_item_2_title(inputs)
	if (locale === "ms") return ms_about_content_honor_0_item_2_title(inputs)
	if (locale === "cs") return cs_about_content_honor_0_item_2_title(inputs)
	if (locale === "el") return el_about_content_honor_0_item_2_title(inputs)
	if (locale === "he") return he_about_content_honor_0_item_2_title(inputs)
	if (locale === "af") return af_about_content_honor_0_item_2_title(inputs)
	if (locale === "hu") return hu_about_content_honor_0_item_2_title(inputs)
	return en_about_content_honor_0_item_2_title(inputs)
});